import { BulkDeleteButton, BulkExportButton, BulkUpdateButton } from "react-admin";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const BulkActionButtons = () => (
    <>
        <BulkExportButton />
        <BulkDeleteButton mutationMode="pessimistic" />
    </>
);

export const VisibilityBulkActionButtons = () => (
    <>
        <BulkUpdateButton
            label="Make public"
            data={{ is_public: true }}
            icon={<Visibility />}
            mutationMode="pessimistic"
        />
        <BulkUpdateButton
            label="Make private"
            data={{ is_public: false }}
            icon={<VisibilityOff />}
            mutationMode="pessimistic"
        />
        <BulkExportButton />
        <BulkDeleteButton mutationMode="pessimistic" />
    </>
);
